export const handleRenderLink = (user) => {

    const links = [
        {
            name: "home",
            to: "/",
            renderd: true
        },
        {
            name: "about",
            to: "/about-us",
            renderd: true

        }, {
            name: "browse-listing",
            to: "/browse-listing",
            renderd: true
        },
        {
            name: "rent",
            to: "/add-new-product",
            // Hide from center nav when logged in — it's the prominent button on the right
            renderd: user ? false : false

        },
        {
            name: "categories",
            to: "/categories",
            renderd: true
        },
        {
            name: "contact",
            to: "/contact-us",
            renderd: true

        }, {
            name: "chat",
            to: "/chat",
            renderd: !!user
        }, {
            name: "admin",
            to: "/admins",
            renderd: user?.role === "Admin" ? true : false

        },
    ]
    return links;
}
